import React from 'react';
import Config from '~/config';

const MetaTwitter = ({ url, title, description, image }) => {
  return (
    <>
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:site" content={Config.redirectURL} />
      <meta name="twitter:creator" content="@ACworks2011" />
    </>
  );
};

export default MetaTwitter;
